import useBankAccounts from "@portal/hooks/useBankAccounts";
import Typography from "@portal/components/atoms/v2/typography";
import { TextResources } from "@portal/assets/text/TextResources";
import { FC, ReactElement } from "react";
import { IBankAccountsSelectProps } from "./types";
import { SelectBox, SelectOption } from "@portal/components/atoms/selectBox";
import Spinner from "@portal/components/atoms/v2/spinner";
import { IBankAccount } from "@portal/types/api/IBankAccount";
import { OptionProps } from "@portal/components/atoms/selectBox/types";

const BankAccountSelect: FC<IBankAccountsSelectProps> = ({
  value,
  onChange,
  typographyVariant,
  label,
  labelVariant = "DescriptionBold",
  includeOtherAccount = true,
  spaced,
  error,
}) => {
  const { bankAccounts, isLoading } = useBankAccounts();
  const variant = typographyVariant ? typographyVariant : "Body";

  const headerPlaceHolder = () => {
    return isLoading ? (
      <div className="flex">
        <Spinner size="small" />
      </div>
    ) : (
      <Typography variant={variant}>
        {includeOtherAccount ? TextResources.FUND_ACCOUNT_OTHER : TextResources.CHOOSE_BANKACCOUNT_LABEL}
      </Typography>
    );
  };

  const getOptions = (): ReactElement<OptionProps<"" | IBankAccount>>[] => {
    const options: ReactElement<OptionProps<"" | IBankAccount>>[] = [];

    if (includeOtherAccount) {
      options.push(
        <SelectOption key="annenkonto" selectKey="annenkonto" value={""} spaced={spaced}>
          <Typography variant={variant}>{TextResources.FUND_ACCOUNT_OTHER}</Typography>
        </SelectOption>,
      );
    }

    bankAccounts?.map(account => {
      options.push(
        <SelectOption key={account.accountNumber} selectKey={account.accountNumber} value={account} spaced={spaced}>
          <Typography variant={variant}>
            {account.accountNumber.length === 11
              ? `${account.accountNumber.substring(0, 4)}.${account.accountNumber.substring(
                  4,
                  6,
                )}.${account.accountNumber.substring(6, 11)}`
              : account.accountNumber}
          </Typography>
        </SelectOption>,
      );
    });
    return options;
  };

  return (
    <div>
      {label && <Typography variant={labelVariant}>{label}</Typography>}
      <SelectBox
        value={value}
        header={<Typography variant={variant}>{value ? value.name : ""}</Typography>}
        headerPlaceholder={headerPlaceHolder()}
        onChange={onChange}
        spaced={spaced}
        error={error}
      >
        {getOptions()}
      </SelectBox>
    </div>
  );
};

export default BankAccountSelect;
